import { RelationshipModel } from '../Relationships/RelationshipModel'

export class StoredCommandModel {
    id: string = '';

    c: string = '';

    r: RelationshipModel = new RelationshipModel();

    prms: { [key: string]: string } = {};
}